import { ContractType } from '@received/pricing-model';
import { Contract } from '../ContractComponent/Contract';

export const ResellerAgreement = () => {
	return <Contract contractType={ContractType.RESELLER} mainUrlToReturn='../resellers' />;
};
